// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__jd9uK","iconWithCounter":"styles_iconWithCounter__uYMMZ","counterForLabel":"styles_counterForLabel__6ApsC","counterForIcon":"styles_counterForIcon__1PYJ2"};